import { useState } from 'react';
import { BookOpen, Upload, Link as LinkIcon, RefreshCw, Trash2 } from 'lucide-react';
import { useKnowledgeBase } from './hooks/useKnowledgeBase';
import UploadFileModal from './components/UploadFileModal';
import AddUrlModal from './components/AddUrlModal';
import '../Pages.css';

const STATUS_COLOR = {
  ingesting: 'amber',
  ready: 'green',
  failed: 'red',
};

export default function KnowledgeBase() {
  const { docs, loading, error, uploadFile, uploadUrl, remove, retry } = useKnowledgeBase();
  const [showFile, setShowFile] = useState(false);
  const [showUrl, setShowUrl] = useState(false);

  return (
    <div className="page kb-page animate-fade-in">
      <div className="page-header">
        <div className="header-info">
          <div className="copilot-title">
            <div className="ai-badge"><BookOpen size={20} /></div>
            <h2>Knowledge Base</h2>
          </div>
          <p>Sources the agent uses to answer prospect questions.</p>
        </div>
        <div className="header-actions" style={{ display: 'flex', gap: 8 }}>
          <button className="primary-btn" onClick={() => setShowFile(true)}>
            <Upload size={16} /> Upload file
          </button>
          <button className="primary-btn" onClick={() => setShowUrl(true)}>
            <LinkIcon size={16} /> Add URL
          </button>
        </div>
      </div>

      {error && <div className="copilot-card error"><div className="card-row error-text">{error}</div></div>}
      {loading && <div className="copilot-card"><div className="card-row muted">Loading…</div></div>}

      <div className="kb-list">
        {docs.length === 0 && !loading && (
          <div className="copilot-card">
            <div className="card-title">No sources yet</div>
            <div className="card-row muted">
              Upload a PDF, DOCX, MD, TXT or paste a URL. The agent will use these to answer questions from prospects.
            </div>
          </div>
        )}
        {docs.map((d) => (
          <div key={d.id} className="copilot-card kb-doc-row">
            <div className="kb-doc-main">
              <div className="card-title">{d.name}</div>
              <div className="card-row muted">
                {d.source_type.toUpperCase()} · {d.chunk_count} chunks · {(d.char_count / 1000).toFixed(1)}k chars
              </div>
            </div>
            <div className={`kb-doc-status status-${STATUS_COLOR[d.status] || 'grey'}`}>
              {d.status}
              {d.status === 'failed' && (
                <button className="text-btn" onClick={() => retry(d.id)}>
                  <RefreshCw size={12} /> Retry
                </button>
              )}
            </div>
            <button className="icon-btn" onClick={() => remove(d.id)} aria-label="Delete">
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>

      {showFile && (
        <UploadFileModal
          onClose={() => setShowFile(false)}
          onUpload={uploadFile}
        />
      )}
      {showUrl && (
        <AddUrlModal
          onClose={() => setShowUrl(false)}
          onAdd={uploadUrl}
        />
      )}
    </div>
  );
}
